import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from './../../../services/authentication.service';
import { Component, OnInit } from '@angular/core';
import { MenuData, SideMenu } from '../../../models/appointments.model';

import { AppointmentService } from '../../../services/appointment.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  status: boolean = false;
  activeClass:boolean=false
  clickEvent(status: String) {
    this.status = !this.status;
  }
  inactiveClass(){
    this.activeClass=false
  }

  getActive(url:any){
     if(url==this.router.url){
      this.activeClass=true
    }
    else{
      this.activeClass=false
    }
  }
  getClassSpan(status: String) {
    if(this.router.url==status){
      return 'active'
    }
    else{
      return ''
    }
  }

  menuList: any[] = [];
  fullUserName!: string;
  role: any;

  constructor(
    private appService: AppointmentService,
    private auth: AuthenticationService,
    private router: Router,
    private activatedRoute:ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.activeClass=true
    this.appService.getSideMenuDetails().subscribe((res) => {
      this.menuList = res.data;
      this.menuList.forEach(element => {
          if(element.achorValue==this.router.url){
            this.activeClass=false
          }
      });
    });
    this.fullUserName = '' + this.auth.getUserFullName();
    this.role = this.auth.getUserType();
  }
  logout() {
    console.log("log method called")
    this.auth.logout().subscribe(
      (res: any) => {},
      (err) => {
        console.log('err' + err.error.message);
      }
    );
    this.router.navigate(['']);
  }
}
